module.exports = __webpack_public_path__ + "assets/863e2c44dd6c05cf3d34627baf59923a.mp3";